import { BaseElement } from './base-element';
import { ElementType } from './element-type';
import { TargetType } from './target-type';

export class File extends BaseElement {
  name: string = '';
  mimeType: string = '';
  target: TargetType = TargetType.open;
  data: string = '';

  constructor() {
    super();
    this.elementType = ElementType.file;
  }
}
